export const formatNumber = (number: number) => {
  if (typeof number !== 'number') {
    throw new Error('Input must be a number');
  }

  if (number >= 1000000) {
    return (number / 1000000).toFixed(2) + 'M';
  }
  if (number >= 1000) {
    return (number / 1000).toFixed(2) + 'K';
  }

  return number.toString();
};
